

<template>
  <!-- Contact Area Start -->
  <section class="contact_details_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="single_contact_box">
            <div class="contact_icon">
              <i class="fas fa-map-marked-alt"></i>
            </div>
            <div class="contact_head">
              <h4>Location</h4>
            </div>
            <div class="contact_text">
              <p>City Street Suice 2/A Sydney, <br> Australia 58000</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="single_contact_box">
            <div class="contact_icon">
              <i class="fas fa-phone-alt"></i>
            </div>
            <div class="contact_head">
              <h4>Phones</h4>
            </div>
            <div class="contact_text">
              <p>+008 - 5069 - 9600</p>
              <p>+009 - 5069 - 5801</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="single_contact_box">
            <div class="contact_icon">
              <i class="fa fa-envelope"></i>
            </div>
            <div class="contact_head">
              <h4>Email</h4>
            </div>
            <div class="contact_text">
              <p>support@example.com</p>
              <p>info@example.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Contact Area End -->
</template>
<script>
export default {
  name: 'ContactArea'
}
</script>



// WEBPACK FOOTER //
// src/components/ContactArea.vue